import { Directive, ViewContainerRef, ContentChildren } from '@angular/core';
import { ComplexBase, ArrayBase, setValue } from '@syncfusion/ej2-angular-base';



let /** @type {?} */ input: string[] = ['disabled', 'iconCss', 'id', 'separator', 'text', 'url'];
let /** @type {?} */ outputs: string[] = [];
export class DropDownButtonItemDirective extends ComplexBase<DropDownButtonItemDirective> {
public directivePropList: any;
/**
 * Used to enable or disable the item.
 * \@default false
 */
public disabled: any;
/**
 * Defines class/multiple classes separated by a space for the item that is used to include an icon. 
 * Action item can include font icon and sprite image.
 * \@default ''
 */
public iconCss: any;
/**
 * Specifies the id for item.
 * \@default ''
 */
public id: any;
/**
 * Specifies separator between the items. Separator are horizontal lines used to group action items.
 * \@default false
 */
public separator: any;
/**
 * Specifies text for item.
 * \@default ''
 */
public text: any;
/**
 * Specifies url for item that creates the anchor link to navigate to the url provided.
 * \@default ''
 */
public url: any;
/**
 * @param {?} viewContainerRef
 */
constructor(private viewContainerRef:ViewContainerRef) {
        super();
        setValue('currentInstance', this, this.viewContainerRef);
        this.registerEvents(outputs);
        this.directivePropList = input;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: 'e-dropdownbuttonitems>e-dropdownbuttonitem',
    inputs: input,
    outputs: outputs,    
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
}

function DropDownButtonItemDirective_tsickle_Closure_declarations() {
/** @type {?} */
DropDownButtonItemDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropDownButtonItemDirective.ctorParameters;
/** @type {?} */
DropDownButtonItemDirective.prototype.directivePropList;
/**
 * Used to enable or disable the item.
 * \@default false
 * @type {?}
 */
DropDownButtonItemDirective.prototype.disabled;
/**
 * Defines class/multiple classes separated by a space for the item that is used to include an icon. 
 * Action item can include font icon and sprite image.
 * \@default ''
 * @type {?}
 */
DropDownButtonItemDirective.prototype.iconCss;
/**
 * Specifies the id for item.
 * \@default ''
 * @type {?}
 */
DropDownButtonItemDirective.prototype.id;
/**
 * Specifies separator between the items. Separator are horizontal lines used to group action items.
 * \@default false
 * @type {?}
 */
DropDownButtonItemDirective.prototype.separator;
/**
 * Specifies text for item.
 * \@default ''
 * @type {?}
 */
DropDownButtonItemDirective.prototype.text;
/**
 * Specifies url for item that creates the anchor link to navigate to the url provided.
 * \@default ''
 * @type {?}
 */
DropDownButtonItemDirective.prototype.url;
/** @type {?} */
DropDownButtonItemDirective.prototype.viewContainerRef;
}

/**
 * DropDownButtonItem Array Directive
 */
export class DropDownButtonItemsDirective extends ArrayBase<DropDownButtonItemsDirective> {
constructor() {
        super('items');
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: 'ejs-dropdownbutton>e-dropdownbuttonitems',
    queries: {
        children: new ContentChildren(DropDownButtonItemDirective)
    },
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DropDownButtonItemsDirective_tsickle_Closure_declarations() {
/** @type {?} */
DropDownButtonItemsDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropDownButtonItemsDirective.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
